import { User } from 'shared/types/user'

import { LoginResponse } from '../login/login.types'

export interface ActivateRequest {
  token: string
}

interface ActivateData
  extends Pick<
    LoginResponse,
    'access_token' | 'refresh_token' | 'token_type' | 'expires_in'
  > {
  user: User
}

export interface ActivateResponse {
  data: ActivateData
  message: string
}
